import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useContext, useEffect, useMemo } from 'react';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

import FormCadastrarEditarProduto from '../../../../../components/forms/FormCadastrarEditarProduto';

export default function CadastrarProdutos() {
	const { setters } = useContext(SidebarHelpContext);
	const { setDataSidebar } = setters;

	const helpCadastroProdutos = useMemo(
		(): ISidebarHelp => ({
			title: 'Cadastrar Produtos',
			firstParagraph:
				'Para cadastrar um novo produto, selecione se ele participa do rateio, entre com o nome do Produto, Código do produto, Família e Subfamília.',
			secondParagraph:
				'Para cadastrar um produto em uma nova família, clique no campo de família e no botão Adicionar.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	useEffect(() => {
		setDataSidebar(helpCadastroProdutos);
	}, [helpCadastroProdutos, setDataSidebar]);

	const formInitialState = {
		nome_produto: '',
		codigo_produto: '',
		custo: '',
		familia_id: '',
		sub_familia_id: '',
		status: true,
		rateio: true,
	};

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='0px'>
				<FormCadastrarEditarProduto initialState={formInitialState} />
			</Card>
		</Flex>
	);
}
